// import helpers
import dbrowser from "./dbrowser";
import ddate from "./ddate";
import deidentitet from "./deidentitet";
import dfilehelper from "./dfilehelper";
import dformatter from "./dformatter";
import dfunctions from "./dfunctions";
import dmath from "./dmath";
import drandom from "./drandom";
export function inithelpers(app)
{
    app.config.globalProperties.$dbrowser = dbrowser;
    app.config.globalProperties.$ddate = ddate;
    app.config.globalProperties.$deidentitet = deidentitet;
    app.config.globalProperties.$dfilehelper = dfilehelper;
    app.config.globalProperties.$dformatter = dformatter;
    app.config.globalProperties.$dfunctions = dfunctions;
    app.config.globalProperties.$dmath = dmath;
    app.config.globalProperties.$drandom = drandom;
}